import * as React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import ProtectedRoute from './ProtectedRoute';
import Login from "../components/Login/Login";
import RegistrationAttendace from '../components/RegisterAttendance/RegisterAttendace';
import 'react-toastify/dist/ReactToastify.css';
import Subordinate from "../components/Subordinate/Subordinate";
import LoadingOverlay from 'react-loading-overlay';
import {connect} from "react-redux";
 

const AppRouter = (props) =>{
    return(
    
        <LoadingOverlay
        active={props.user.isLoading}
        spinner
        >
                <Router>
                <Switch>
                    <ProtectedRoute permission="Atency.AttendanceLogAPI.AddAtendanceLog" path="/" component={RegistrationAttendace}  exact={true} />
                    <Route path="/login" component={Login}  exact={true}/>
                    <ProtectedRoute permission="Atency.PersonnelAPI.DeletePersonnel" path="/subordinates" component={Subordinate}  exact={true}/>
                </Switch>
                </Router>
        </LoadingOverlay>
);
}
const mapToStateProps = (state) =>{
    return state;
}
export default connect(mapToStateProps)(AppRouter);
